enum ThemeSpacingEnum {
	space25 = 'space25',
	space50 = 'space50',
	space75 = 'space75',
	space100 = 'space100',
	space125 = 'space125',
	space150 = 'space150',
	space200 = 'space200',
	space250 = 'space250',
	space300 = 'space300',
	space400 = 'space400',
	space550 = 'space550',
	space750 = 'space750'
}

export default ThemeSpacingEnum;
